/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import ShapeEnum, { getShapeToCount } from 'shared/enum/shape';


export default class
{
  constructor (parent)
  {
    this.parent = parent;
  }


  installInfluence (target, shape, influence)
  {
    switch(shape.type)
    {
      case ShapeEnum.Sector: this.installSectorInfluence(target, influence); return;
      case ShapeEnum.Splash: this.installSplashInfluence(target, influence); return;
      case ShapeEnum.Single: this.installSingleInfluence(target, influence); return;
      default:               this.installDirectInfluence(target, shape, influence); return;
    }
  }


  installSectorInfluence (target, influence)
  {
    // no-op.
  }


  installSplashInfluence (target, influence)
  {
    // no-op.
  }


  installSingleInfluence (target, influence)
  {
    // no-op.
  }


  installDirectInfluence (target, shape, influence)
  {
    // no-op.
  }


};
